module.exports = __webpack_public_path__ + "img/status.c8b1fa91.svg";